module.exports = __webpack_public_path__ + "static/media/social-youtube.400ad823.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/social-youtube.svg
// module id = 351
// module chunks = 0